__turbopack_context__.v({
  "count": "KNIK8a_count",
  "pax": "KNIK8a_pax",
  "row": "KNIK8a_row",
  "rows": "KNIK8a_rows",
  "summary": "KNIK8a_summary",
  "total": "KNIK8a_total",
  "totalPax": "KNIK8a_totalPax",
});
